import styled from "styled-components"

import {Label} from "@irati/ui/src/Typography"

export default styled(Label)`
    line-height: 40px;
    height: 40px;
    flex-grow: 2;
`
